import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import css_248z from './page-utility-bar.scss.js';

class PageUtilityBar extends s {
    render() {
        return $ `<div class="bar"><div class="start"><slot></slot></div><div class="end"><slot name="actions"></slot></div></div>`;
    }
}
PageUtilityBar.styles = css_248z;
customElements.define('page-utility-bar', PageUtilityBar);

export { PageUtilityBar };
